import { render, staticRenderFns } from "./djgyy.vue?vue&type=template&id=6e3a00a4&scoped=true&"
import script from "./djgyy.vue?vue&type=script&lang=js&"
export * from "./djgyy.vue?vue&type=script&lang=js&"
import style0 from "./djgyy.vue?vue&type=style&index=0&id=6e3a00a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a00a4",
  null
  
)

export default component.exports